// extracted by mini-css-extract-plugin
export var productImage = "_n1-0";